import React, { useState } from 'react'
import PageBody from 'Common/Custom/PageBody'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import VehicleListTable from './Components/VehicleListTable'
import { useRoleVerify } from 'Common/RoleVerify'
import AddVehicleType from '../AddVehicleType/AddVehicleType'

const VehicleList = () => {
    const [refetch, setRefetch] = useState(false)
    const canShowAction = useRoleVerify("", ["can_create"]);
    return (
        <>
            {canShowAction &&
                <AddVehicleType
                    setRefetch={setRefetch}
                    refetch={refetch}
                />}
            <PageBody
                card={true}
                headerchildren={
                    <HeadingOne>Vehicle List</HeadingOne>
                }>
                {/* Table section */}
                <div className="col-12">
                    <VehicleListTable refetch={refetch} />
                </div>
            </PageBody>
        </>
    )
}

export default VehicleList
